if (!window.Eurus.loadedScript.includes('cdc-polar-event.js')) {
  window.Eurus.loadedScript.push('cdc-polar-event.js');
  
  requestAnimationFrame(() => {
    document.addEventListener("alpine:init", () => {
      Alpine.store("xPolarEvent", {
        shopURL: window.Shopify?.shop || '',
        pixelURL: "https://api-production.polaranalytics.com/pixel",
        async custom(eventName , eventData = null) {
          try {
            const payloadBase = await polarPixel.generatePayloadBase({});
            const data = polarPixel.eventFactory.custom({
              shopifyEventName: eventName,
              shopifyEventId:
                (crypto && crypto.randomUUID && crypto.randomUUID()) ||
                String(Date.now()),
              shopifyClientId: String(payloadBase.data.userId || ""),
              shopifyShopURL: this.shopURL,
              ...(eventData != null && { shopifyEventData: eventData })
            });
            await polarPixel.sendPixelEvent(
              "https://api-production.polaranalytics.com/pixel",
              payloadBase,
              {
                data,
              }
            );
            
          } catch (error) {
            console.log(error);
          }
        }
      });
    })
  });
}